import styles from './ActiveEvent.module.scss'

interface Event {
  id: number
  title: {
    rendered: string
  }
  thumbnail_img?: string
  start_date?: string
  end_date?: string
  duration?: string
  status01?: string
  status01_color?: string
  status02?: string
  status02_color?: string
}

interface Props {
  activeEvents: Event[]
  getEventDateDisplay: (event: Event) => string
}

const ActiveEvent: React.FC<Props> = ({ activeEvents, getEventDateDisplay }) => {
  return (
    <div className={styles.rightContents}>
      <h2 className={styles.rightContents_title}>開催予定のセミナー・イベント</h2>
      {activeEvents && activeEvents.length > 0 ? (
        activeEvents.map((event) => (
          <div key={event.id} className={styles.rightContents_item}>
            <a href={`/events/${event.id}`}>
              <figure className={styles.rightContents_item_img}>
                <img
                  src={event.thumbnail_img || '/images/img/img_thumbnail_dummy.png'}
                  alt={event.title.rendered || 'デフォルト画像'}
                />
              </figure>
              <div className={styles.rightContents_item_text}>
                <div className={styles.rightContents_item_text_status}>
                  <span className={styles.rightContents_item_text_status_date}>
                    {getEventDateDisplay(event)}
                    {event.duration && `  ${event.duration}`} 開催
                  </span>
                </div>
                <span className={styles.rightContents_item_text_title}>{event.title.rendered}</span>
              </div>
            </a>
          </div>
        ))
      ) : (
        <p>現在開催中のイベントはありません</p>
      )}
    </div>
  )
}

export default ActiveEvent
